<div>
    <div style="width: 100%; padding: 3px; border-bottom: 3px solid #9DB2BF; ">
        <div class="container" style="max-width: 100% !important; color: white;">
            <div fxLayout="row">
                <div class="center-vertical" class="profile" fxFlex="10%"><img src="assets/logos/icon_enovsky.png"></div>
                <div class="center-vertical" fxFlex="30%" style="white-space: nowrap;">
                    <mat-icon [ngClass]="cropType == 'rounded'? 'icon-active': 'icon-inactive'" style="cursor: pointer; font-size: 20px; margin-left: 15px;" aria-hidden="false" fontIcon="crop" title="Crop" (click)="setCropType('rounded')"></mat-icon>
                    <mat-icon [ngClass]="cropType == 'rectangle'? 'icon-active': 'icon-inactive'" style="cursor: pointer; font-size: 20px; margin-left: 15px;" aria-hidden="false" fontIcon="rectangle" title="Rectangle" (click)="setCropType('rectangle')"></mat-icon>
                    <mat-icon [ngClass]="cropType == 'ellipse'? 'icon-active': 'icon-inactive'" style="cursor: pointer; font-size: 20px; margin-left: 15px;" aria-hidden="false" fontIcon="circle" title="Circle" (click)="setCropType('ellipse')"></mat-icon>
                </div>
                <div class="center-vertical" fxFlex="40%">
                    <mat-select *ngIf="sourceModal == 'geogebra'" placeholder="Supplier" [formControl]="appNameControl" (selectionChange)="switchApplication()">
                        <mat-option value="classic">Classic</mat-option>
                        <mat-option value="graphing">Graphing Calculator</mat-option>
                        <mat-option value="geometry">Geometry</mat-option>
                        <mat-option value="3d">3D Calculator</mat-option>
                    </mat-select>
                </div>
                <div fxFlex="20%" style="display: flex; align-items: center;">
                    <div style="margin: auto; display: flex;">
                        <button class="button-secondary-small" (click) = "exportSVG()">Insert</button>
                        <mat-icon style="color: gray; cursor: pointer; font-size: 20px; margin-left: 15px;" aria-hidden="false" fontIcon="close" title="Close" (click)="onClose()"></mat-icon>
                    </div>
                </div>
            </div>
        </div>
        <mat-progress-bar *ngIf="inProgress" class="progress_bar" mode="buffer"></mat-progress-bar>
        
    </div>
   
    <div *ngIf="sourceModal == 'geogebra'" #ggbContainer style="width: 100vw; height: calc(100vh - 20px);"></div>
    <div *ngIf="sourceModal == 'chemistry'" class="chemistry-wrapper">
        <iframe #ketcherFrame src="assets/chemistry-ketcher/index.html" (load)="onKetcherLoad()"> </iframe>
    </div>
    <div *ngIf="sourceModal == 'crop_image'" class="modal-container">
        <img #imageCropper [src]="data.image" style="max-width: 100vw; max-height: 70vh;" alt="To crop" />
    </div>

</div>